import { useState, useEffect } from 'react';
import { Stack, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import axios from 'axios';
import NoticeTypeButtons from './common/NoticeTypeButtons';
import SectionAndStationSelects from './common/SectionAndStationSelects';
import ReasonButtons from './common/ReasonButtons';
import { REASONS } from '../common/constants';
import { MESSAGES } from '../common/messages';
import { isVerticalIpadMini } from '../common/responsiveUtils';
import { enqueueSnackbar } from 'notistack';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';

const CreateNoticeTemplateDialog = (props) => {
  const { typography } = useTheme();
  const styles = {
    cancelButton: {
      ...typography.label14,
      width: '224px',
      height: '44px',
      borderRadius: '100px',
      marginLeft: 'auto',
      marginRight: '8px',
      borderColor: 'primary.light',
      color: 'primary.light',
    },
    submitButton: {
      ...typography.label14bold,
      width: '232px',
      height: '44px',
      borderRadius: '100px',
      marginRight: 'auto',
      backgroundColor: 'primary.light',
    },
  };

  const initialValue = {
    noticeCategoryCode: 0,
    noticeTypeCode: 0,
    sectionCode: '',
    startStationCode: '',
    endStationCode: '',
    reasonCode: REASONS.NULL.value,
  };

  const [notice, setNotice] = useState(initialValue);
  const [masterData, setMasterData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get('/v1/sections');
        setMasterData(data);
      } catch (err) { }
    };
    fetchData();
  }, []);

  const handleChange = (inputObj) => {
    const copied = structuredClone(notice);
    setNotice(Object.assign(copied, inputObj));
  };

  const handleClose = () => {
    props.setOpen(false);
    setNotice(initialValue);
  };

  const handleSubmit = async () => {
    try {
      const res = await axios.post('/v1/notice-templates', notice);
      props.setTemplates([res.data].concat(props.templates));
      handleClose();
      enqueueSnackbar(MESSAGES.TEMPLATE_CREATED);
    } catch (err) {
      if (err.templateConflict) {
        enqueueSnackbar(err.templateConflict, { variant: 'error' });
      }
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      fullWidth
      maxWidth='lg'
      PaperProps={{ sx: { margin: '0px', width: isVerticalIpadMini() ? '740px' : '980px' } }}
    >

      <DialogTitle variant='body16bold' textAlign='center' position='relative'>
        通告テンプレート追加登録
        <IconButton
          sx={{ position: 'absolute', right: '6px', top: '0px', bottom: '0px' }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ padding: '16px', paddingBottom: '24px' }}>
        <Stack sx={{ padding: '24px', marginBottom: '16px' }}>
          {/* 通告の種類 */}
          <NoticeTypeButtons
            notice={notice}
            handleChange={handleChange}
          />
          {/* 線区と区間 */}
          <SectionAndStationSelects
            notice={notice}
            handleChange={handleChange}
            masterData={masterData}
          />
          {/* 事由 */}
          <ReasonButtons
            reasonCode={notice.reasonCode}
            handleChange={handleChange}
          />
        </Stack>
        <DialogActions sx={{ padding: '24px', display: 'block' }}>
          <Stack direction='row'>
            <Button
              variant='outlined' sx={styles.cancelButton}
              onClick={handleClose}
            >
              キャンセル
            </Button>
            <Button
              variant='contained' disableElevation sx={styles.submitButton}
              disabled={!notice.sectionCode || !notice.startStationCode || !notice.endStationCode}
              onClick={() => handleSubmit()}
            >
              登録
            </Button>
          </Stack>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default CreateNoticeTemplateDialog;

CreateNoticeTemplateDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  templates: PropTypes.array,
  setTemplates: PropTypes.func,
};
